import { createMuiTheme } from "@material-ui/core/styles"

export const fontTheme = createMuiTheme({
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "*, *::before, *::after": {
          boxSizing: "content-box",
        },

        body: {
          color: "#232323",
          backgroundColor: "#fff",
        },
      },
    },
  },
  palette: {
    primary: {
      // Purple and green play nicely together.
      main: "#077F83",
      light: "#077f837a",
      contrastText: "#fff",
    },
    secondary: {
      // This is green.A700 as hex.
      main: "#EF7000",
    },
  },
  typography: {
    h1: {
      fontSize: "24px",
      fontFamily: "Lato",
    },
    h2: {
      fontSize: "16px",
      fontFamily: "Open Sans",
    },
    subtitle1: {
      fontSize: "18px",
      fontFamily: "Open Sans",
    },
    button: {
      fontSize: "14px",
      fontFamily: "Open Sans",
      lineHeight: "16px",
      height: "35px",
    },
  },
})

// .wrapper {
//     color: "#232323";
//     font-family: "Calibri";
//     background-color: "#F9FAFE";
// }

// .h1 {
//     font-size: 22px !important;
//     line-height: 27px !important
// }

// .h2 {
//     font-size: 20px !important;
//     line-height: 25px !important;
// }

// .h3 {
//     font-size: 18px !important;
//     line-height: 23px !important;
// }

// .h4 {
//     font-size: 16px !important;
//     line-height: 20px !important;
// }

// .h5 {
//     font-size: 15px !important;
//     line-height: 25px !important;
// }

// .h6 {
//     font-size: 12px !important;
//     line-height: 15px !important;
// }

// .h7 {
//     font-size: 11px !important;
//     line-height: 18px !important;
// }

// .fontCalibri {
//     font-family: "Calibri";
// }

// .fontNormal {
//     font-weight: "300";
// }

// .fontSemiBold {
//     font-weight: "500";
// }

// .fontBold {
//     font-weight: "700";
// }
